import { Box, BoxProps, Link, Text } from '@chakra-ui/react'
import React from 'react'
import { isBefore3pmEastern } from '../../utils'

const TransferSubmissionInfo = (boxProps?: BoxProps) => (
  <Box data-testid="transfer-submission-info" {...boxProps}>
    <Text data-testid="submission-info">
      Account Transfers are submitted immediately, but not processed on weekends
      or banking holidays.
      <br />
      Please send documents, signatures, and other validation paperwork to{' '}
      <Link color="apex.link" href="mailto: docimaging@apexclearing.com">
        docimaging@apexclearing.com
      </Link>
    </Text>
    {isBefore3pmEastern() || (
      <Text color="apex.orangeRed" marginTop="2rem">
        Transfers requested after 2:00 PM CT (3:00 PM ET) will be processed the
        next business day.
      </Text>
    )}
  </Box>
)

export default TransferSubmissionInfo
